import type NumberUnit from '@exodus/currency';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

type FiatBalances =
  | {
      [assetName: string]: NumberUnit;
    }
  | undefined;

type UseFiatBalanceValue = {
  value?: NumberUnit;
  loading: boolean;
};

const useFiatBalance = (assetName: string): UseFiatBalanceValue => {
  const loaded = useSelector<unknown, boolean>(selectors.fiatBalances.loaded);
  const fiatBalances = useSelector<unknown, FiatBalances>(
    selectors.fiatBalances.byAssetInActiveAccount,
  );

  return {
    value: fiatBalances?.[assetName],
    loading: !loaded,
  };
};

export default useFiatBalance;
